import PropTypes from 'prop-types';
import React from 'react';
import isEmpty from 'lodash/isEmpty';
import classname from 'classname';

const Input = props => {
	const className = classname({
		'form-element': true,
		active: isActive(props),
		'has-error': hasError(props),
		[props.className ? props.className : null]: !!props.className
	});

	return (
		<div className={className}>
			<input
				type={props.type || 'text'}
				className="form-element__control font-proxima-nova-regular"
				{...props.input}
				autoComplete={props.autoComplete}
				disabled={props.shouldDisable}
				onChange={props.onChange || props.input.onChange}
			/>
			<label className="form-element__label"  htmlFor={props.input.name}>
				{hasError(props) ? `${props.placeholder} (${errorValue(props)})` : props.placeholder}
			</label>
		</div>
	);
};

const isActive = props => props.meta.active || !isEmpty(props.input.value);
const hasError = props => props.meta.touched && props.meta.error;
const errorValue = props => {
	return props.meta.error;
};

Input.propTypes = {
	placeholder: PropTypes.string,
	input: PropTypes.object,
	meta: PropTypes.object,
	shouldDisable: PropTypes.bool,
	className: PropTypes.string,
	type: PropTypes.string,
	onChange: PropTypes.func,
	autoComplete: PropTypes.string
};

export default Input;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/form-elements/input.js